<template>
	<div class="Default">
		Default
	</div>
</template>

<script>
	export default {
		data() {
			return {
				
			}
		},
		created() {
			
		},
		mounted() {
			
		},
		methods: {
			
		}
	}
</script>

<style lang="scss">
	.Default {
		
	}
</style>
